import { render, staticRenderFns } from "./person_info.vue?vue&type=template&id=c39fbba4&scoped=true"
import script from "./person_info.vue?vue&type=script&lang=js"
export * from "./person_info.vue?vue&type=script&lang=js"
import style0 from "./person_info.vue?vue&type=style&index=0&id=c39fbba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39fbba4",
  null
  
)

export default component.exports